<template>
  <base-dialog
    :input="{}"
    :rules="{}"
    :width="'600px'"
    :title="'导出'"
    :dialogVisible.sync="_dialogVisible"
    @submit="confirmClick"
  >
    <div style="display: flex;flex-direction: column;margin-left: 200px">
      <div style="margin-bottom: 10px">
        <input type="radio" id="data" v-model="_exportType" for-test="_exportType"
               value="data">
        <label class="radioLabel" for="data">仅导出数据</label>
      </div>
      <!-- <div>
        <input type="radio" id="dataAndPic" v-model="_exportType" for-test="_exportType"
               value="dataAndPic">
        <label class="radioLabel" for="dataAndPic">导出图片+数据</label>
      </div> -->
<!--      <el-radio style="margin-bottom: 10px" v-model="_exportType" for-test="_exportType" label="data">仅导出数据</el-radio>-->
<!--      <el-radio v-model="_exportType" for-test="_exportType" label="dataAndPic">导出图片+数据</el-radio>-->
    </div>
  </base-dialog>
</template>
<style scoped lang="scss">
.radioLabel{
  margin-left: 5px;
}

</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/business-components/data-export-dialog/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/business-components/data-export-dialog/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/business-components/data-export-dialog/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-business-data-export-dialog')
  export default {
    name: 'business-data-export-dialog', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'business-data-export-dialog': require('%path').default,
       */
      /*start:import components file*/
'base-account-info': require('./../../base-components/account-info/index.vue').default,
       'base-back': require('./../../base-components/back/index.vue').default,
       'base-blackHandle': require('./../../base-components/blackHandle/index.vue').default,
       'base-bottomFloat': require('./../../base-components/bottomFloat/index.vue').default,
       'base-card-header': require('./../../base-components/card-header/index.vue').default,
       'base-carDriverInfo': require('./../../base-components/carDriverInfo/index.vue').default,
       'base-cascader-select-on-click': require('./../../base-components/cascader-select-on-click/index.vue').default,
       'base-check-all': require('./../../base-components/check-all/index.vue').default,
       'base-cropper': require('./../../base-components/cropper/index.vue').default,
       'base-datetimerange': require('./../../base-components/datetimerange/index.vue').default,
       'base-dialog': require('./../../base-components/dialog/index.vue').default,
       'base-empty': require('./../../base-components/empty/index.vue').default,
       'base-export': require('./../../base-components/export/index.vue').default,
       'base-filter': require('./../../base-components/filter/index.vue').default,
       'base-image-carousel': require('./../../base-components/image-carousel/index.vue').default,
       'base-img-base': require('./../../base-components/img-base/index.vue').default,
       'base-img-viewer': require('./../../base-components/img-viewer/index.vue').default,
       'base-key-value': require('./../../base-components/key-value/index.vue').default,
       'base-my-column': require('./../../base-components/my-column/index.vue').default,
       'base-number-input': require('./../../base-components/number-input/index.vue').default,
       'base-plate': require('./../../base-components/plate/index.vue').default,
       'base-quarter-datepicker': require('./../../base-components/quarter-datepicker/index.vue').default,
       'base-simple-menu': require('./../../base-components/simple-menu/index.vue').default,
       'base-yearrange': require('./../../base-components/yearrange/index.vue').default,
       /*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>